"use client";

import { c as _c } from "react/compiler-runtime";
import { Button } from "@/components/ui/button";
import { useNewCartStore } from "@/stores/useNewCartStore";
export function CompleteCheckoutButton() {
  const $ = _c(2);
  const setIsCartOpen = useNewCartStore(_temp);
  let t0;
  if ($[0] !== setIsCartOpen) {
    t0 = <Button onClick={() => setIsCartOpen(false)} size="xl" className="w-full">Complete checkout</Button>;
    $[0] = setIsCartOpen;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
}
function _temp(state) {
  return state.setIsCartOpen;
}